export const AVAILABILITY_VISITS = 'visits';
export const AVAILABILITY_FAIRS = 'fairs';
